module.exports = __webpack_public_path__ + "img/legende350.d73fb27c.jpg";